import { useMemo } from 'react';

import { useWorkspaceAgentOnboardingTimeSinkIds } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/onboarding/useWorkspaceAgentOnboardingTimeSinkIds';
import { getWorkspaceAgentOnboardingWinningTimeSink } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentOnboardingWinningTimeSink';

/** The time sink whose demo is on screen. The best priority among the selected pills wins. */
export const useWorkspaceAgentOnboardingWinningTimeSink = () => {
  const { timeSinkIds } = useWorkspaceAgentOnboardingTimeSinkIds();

  const winningTimeSink = useMemo(() => getWorkspaceAgentOnboardingWinningTimeSink(timeSinkIds), [timeSinkIds]);

  return { winningTimeSink };
};
